"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var estimateConfig_1 = require("./estimateConfig");
var trackingConfig_1 = require("./trackingConfig");
var estimate_1 = __importDefault(require("./estimate"));
var tracking_1 = __importDefault(require("./tracking"));
var defaultConfig = {
    host: 'api.arta.io',
    httpSchema: 'https',
};
var Arta = /** @class */ (function () {
    function Arta() {
    }
    Arta.prototype.init = function (apiKey, config) {
        this.config = Object.assign(__assign(__assign({}, defaultConfig), { apiKey: apiKey }), config);
        if (document.querySelectorAll('#arta-widget').length) {
            return;
        }
        this.el = document.createElement('div');
        this.el.id = 'arta-widget';
        document.body.appendChild(this.el);
    };
    Arta.prototype.estimate = function (estimateBody, esimateConfig) {
        if (esimateConfig === void 0) { esimateConfig = {}; }
        if (this.config && this.el) {
            var fullEstimateConfig = (0, estimateConfig_1.getFullEstimateConfig)(this.config, esimateConfig);
            return new estimate_1.default(estimateBody, fullEstimateConfig, this.el);
        }
        else {
            throw new Error('Please initialize the SDK with Arta.init before creating estimates');
        }
    };
    Arta.prototype.tracking = function (shipmentId, trackingConfig) {
        if (trackingConfig === void 0) { trackingConfig = {}; }
        if (this.config && this.el) {
            var fullTrackingConfig = (0, trackingConfig_1.getFullTrackingConfig)(this.config, trackingConfig);
            return new tracking_1.default(shipmentId, fullTrackingConfig, this.el);
        }
        else {
            throw new Error('Please initialize the SDK with Arta.init before creating tracking');
        }
    };
    return Arta;
}());
exports.default = Arta;
